import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {GetForingLang, GetOneLearningLanguage, GetLearningStats, EditLearningLanguage} from '../../actions/index';
import {Link} from 'react-router';


class LearningEdit extends Component {
    static contextTypes = {
        router: PropTypes.object,
        fields: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state={
            active: null
        }
        this.activateBtn = this.activateBtn.bind(this);
        this.deactivateBtn = this.deactivateBtn.bind(this);
        this.OpenModal = this.OpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        if(this.props.params.id){
            this.props.GetOneLearningLanguage(this.props.params.id, token);
            this.props.GetLearningStats(this.props.params.id, token);
        }
    }
    OpenModal(){
        this.props.lang.sentense_detail = {};
        let token = localStorage.getItem('id_token_admin');
        // let that= this;
        $('#ActivateDeactivate').modal('show');
        // $('#ActivateDeactivate').on('shown.bs.modal', function () {
        //     // that.props.getDetailSentense(id, token, flang);
        // });
    }
    activateBtn(){
        let token = localStorage.getItem('id_token_admin');
        this.props.EditLearningLanguage(this.props.lang.learning_lang_one.id, token, true);
        this.props.GetOneLearningLanguage(this.props.params.id, token);
        this.closeModal();
    }
    deactivateBtn(){
        let token = localStorage.getItem('id_token_admin');
        this.props.EditLearningLanguage(this.props.lang.learning_lang_one.id, token, false);
        this.props.GetOneLearningLanguage(this.props.params.id, token);
        this.closeModal();
    }
    closeModal(){
        $('#ActivateDeactivate').modal('hide');
    }
    componentWillUnmount(){
        this.props.lang.learning_lang_one = {};
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                {this.props.lang.learning_lang_one && this.props.lang.learning_lang_one.lang ?
                    <div className="dashboard-title clearfix">
                        <p className="pull-left">{this.props.lang.learning_lang_one.lang.name}</p>
                        {this.props.lang.learning_lang_one.is_active ?
                            <button type="button" onClick={this.OpenModal} className="btn btn-danger pull-right">Deactivate language</button>
                            :
                            <button type="button" onClick={this.OpenModal} className="btn btn-primary pull-right">Activate language</button>
                        }
                    </div>
                    :
                    ""
                }
                <div>
                    <div className="col-md-12">
                        <Link to={"language/learning/edit/"+this.props.params.id+"/sentence"} className="white-block common-list second clearfix">
                            <p>Sentence list</p>
                            <p>{this.props.lang.learning_stats ? this.props.lang.learning_stats['sentences'] : ''} sentences</p>
                        </Link>
                        <Link to={"language/learning/edit/"+this.props.params.id+"/vocabulary"} className="white-block common-list second clearfix">
                            <p>Vocabulary</p>
                            <p>{this.props.lang.learning_stats ? this.props.lang.learning_stats['vocabulary'] : ''} words</p>
                        </Link>
                        <Link to={"language/learning/edit/"+this.props.params.id+"/grammar_page"} className="white-block common-list second clearfix">
                            <p>Grammar Page</p>
                            <p>{this.props.lang.learning_stats ? this.props.lang.learning_stats['grammar_pages'] : ''} pages</p>
                        </Link>
                        <Link to={"language/learning/edit/"+this.props.params.id+"/live_situations"} className="white-block common-list second clearfix">
                            <p>Live Situations</p>
                            <p>{this.props.lang.learning_stats ? this.props.lang.learning_stats['situations'] : ''} situations</p>
                        </Link>
                    </div>
                </div>

                <div className="modal fade" id="ActivateDeactivate" tabIndex="-1" role="dialog" aria-labelledby="ActivateDeactivateLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#ActivateDeactivate"></span>
                                    <p>Do you really want to {this.props.lang.learning_lang_one && this.props.lang.learning_lang_one.is_active ? "deactivate" : "activate"} this language {this.props.lang.learning_lang_one && this.props.lang.learning_lang_one.lang ? <span>{this.props.lang.learning_lang_one.lang.name}</span> : ""}?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.props.lang.learning_lang_one.is_active ? this.deactivateBtn : this.activateBtn} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}
export default connect(mapStateToProps, {GetForingLang, GetOneLearningLanguage, GetLearningStats, EditLearningLanguage})(LearningEdit);



// WEBPACK FOOTER //
// ./src/components/language/learningEdit.js